import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "../User/userSlice";
import cartReducer from "../Cart/cartSlice";

export const rootReducer = combineReducers({
  user: userReducer,
  cart: cartReducer
});